import React,{Component} from "react"

class Logo extends Component{
    render(){
        return (  
                <>
                <h1 className="logo">SatyamGupta</h1>
                </>
        )
    }
}

export default Logo;